document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.es-tab-collection').forEach((root) => {
    const tabs = root.querySelectorAll('.es-tab-collection__tab');
    const panels = root.querySelectorAll('.es-tab-collection__panel');
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetId = tab.getAttribute('data-tab-target');
        tabs.forEach((t) => {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const active = panel.id === targetId;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });
  });
});
